import _ from 'underscore';

import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import {Toast, ToastId} from 'nav/toasts/ToastConstants';

export function pushToast({
  id,
  actions,
  actionText,
  clipboardData,
  duration,
  isCloseable,
  message,
  onActionClick,
  onClose,
  progress,
  skipCloseCallbackOnActions,
  type,
  stack,
}: Toast): ToastId {
  // Autogenerate an id if one is not specified by the caller
  const toastId = id || _.uniqueId();
  AppDispatcher.dispatch({
    actionType: EventConstants.TOAST_PUSH,
    id: toastId,
    actions,
    actionText,
    clipboardData,
    duration,
    isCloseable,
    message,
    onActionClick,
    onClose,
    progress,
    skipCloseCallbackOnActions,
    type,
    stack,
  });
  return toastId;
}

export function closeToast(toastId: ToastId): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.TOAST_CLOSE,
    id: toastId,
  });
}
